import { injectable } from 'inversify';
import 'reflect-metadata';
import {
  PaginatedResult,
  Response,
} from '@/_shared/_api/models/response.model';
import { ERRORS } from '../constants/errors/error-messages.constants';
import { ReportCreditBundles } from '../_api/models/report-credit-bundle.model';
import { CreateBrandReportRequest } from '../models/brand-report/create-brand-report-request.model';
import { CreateBrandReportsRequest } from '../models/brand-report/create-brand-reports-request.model';
import { OpenBrandReportItemRequest } from '../models/brand-report/update-brand-report-item-opened.model';
import axiosClient from './axios-client';

@injectable()
export class BrandReportService {
  async getReportCreditBundles(): Promise<Response<ReportCreditBundles>> {
    try {
      const response = await axiosClient.get<Response<ReportCreditBundles>>(
        '/api/brand-report/credit-bundles'
      );

      const apiResponse = response.data;
      return apiResponse;
    } catch {
      throw new Error(ERRORS.unexpectedError);
    }
  }

  async createBrandReport(
    request: CreateBrandReportRequest
  ): Promise<Response<boolean>> {
    try {
      const response = await axiosClient.post<Response<boolean>>(
        '/api/brand-report/brand-report',
        request
      );

      const apiResponse = response.data;
      return apiResponse;
    } catch {
      throw new Error(ERRORS.unexpectedError);
    }
  }

  async createBrandReports(
    request: CreateBrandReportsRequest
  ): Promise<Response<boolean>> {
    try {
      const response = await axiosClient.post<Response<boolean>>(
        '/api/brand-report/brand-reports',
        request
      );

      const apiResponse = response.data;
      return apiResponse;
    } catch {
      throw new Error(ERRORS.unexpectedError);
    }
  }

  async getPurchasedReportsByUserId(
    id: number,
    offset: number,
    limit: number,
    timezone?: string,
    _paginated?: boolean
  ): Promise<Response<PaginatedResult>> {
    try {
      const response = await axiosClient.get(
        '/api/brand-report/purchased-report',
        {
          params: {
            id: id,
            offset: offset,
            limit: limit,
            timezone: timezone,
            paginated: true,
          },
        }
      );
      return response;
    } catch {
      throw new Error(ERRORS.unexpectedError);
    }
  }

  async getPurchasedReportsCountByUserId(
    id: number
  ): Promise<Response<number>> {
    try {
      const response = await axiosClient.get<Response<number>>(
        '/api/brand-report/purchased-report/count',
        {
          params: {
            id: id,
          },
        }
      );

      const apiResponse = response.data;
      return apiResponse;
    } catch {
      throw new Error(ERRORS.unexpectedError);
    }
  }

  async openBrandReportItem(
    request: OpenBrandReportItemRequest
  ): Promise<Response<boolean>> {
    try {
      const response = await axiosClient.post(
        '/api/brand-report/item/open',
        request
      );
      return response;
    } catch {
      throw new Error(ERRORS.unexpectedError);
    }
  }
}
